import moment from 'moment-timezone';

/**
 * ビジネスえきねっと（代理手配）対応列車名。
 * transport_element.name / 経路 leg.name のいずれかに含まれていれば対象。
 */
export const BUSINESS_EKINET_SUPPORTED_TRAIN_NAMES = [
  // 新幹線（新幹線eチケットサービス）
  'はやぶさ',
  'はやて',
  'やまびこ',
  'なすの',
  'こまち',
  'つばさ',
  'とき',
  'たにがわ',
  'かがやき',
  'はくたか',
  'あさま',
  'つるぎ',
  // 在来線特急（在来線チケットレス特急券）
  'あずさ',
  'かいじ',
  '富士回遊',
  'ひたち',
  'ときわ',
  'サフィール踊り子',
  '踊り子',
  '湘南',
  'あかぎ',
  '草津・四万',
  '草津･四万',
  '草津四万',
  '成田エクスプレス',
  '新宿わかしお',
  'わかしお',
  '新宿さざなみ',
  'さざなみ',
  'しおさい',
  'スーパーつがる',
  'つがる',
  'あかべこ号',
  'あかべこ',
  '鎌倉',
  // トク割として追加案内されている在来線特急
  'しなの',
  '信州',
  'イブニングウェイ',
  // JR北海道の在来線特急（FAQ上のトク割対象）
  '北斗',
  'すずらん',
  'ライラック',
  'カムイ',
  '宗谷'
] as const;

/** 購入操作日（Asia/Tokyo）が availableFrom 以降のときのみ対象になる列車 */
export const BUSINESS_EKINET_DATE_GATED_TRAIN_NAMES: ReadonlyArray<{
  name: string;
  availableFrom: string;
}> = [
  { name: 'いなほ', availableFrom: '2026-11-01' },
  { name: 'しらゆき', availableFrom: '2026-11-01' }
];

const BUSINESS_EKINET_UNSUPPORTED_TRAIN_TOOLTIP = '対象外の列車です';

export const businessEkinetUnsupportedTrainTooltip = (): string => BUSINESS_EKINET_UNSUPPORTED_TRAIN_TOOLTIP;

const tokyoDate = (at: Date | string | moment.Moment = moment()) =>
  moment.tz(at, 'Asia/Tokyo').format('YYYY-MM-DD');

export const isBusinessEkinetSupportedTrainName = (
  trainName: string | null | undefined,
  at: Date | string | moment.Moment = moment()
): boolean => {
  if (!trainName) {
    return false;
  }

  if (BUSINESS_EKINET_SUPPORTED_TRAIN_NAMES.some(name => trainName.includes(name))) {
    return true;
  }

  const today = tokyoDate(at);
  return BUSINESS_EKINET_DATE_GATED_TRAIN_NAMES.some(
    ({ name, availableFrom }) => today >= availableFrom && trainName.includes(name)
  );
};

/**
 * 新幹線・特急の全区間が対応列車のときのみ true。
 * 対象区間が無い場合は false。
 */
export const isBusinessEkinetSupportedByTrainNames = (
  trainNames: ReadonlyArray<string | null | undefined>,
  at: Date | string | moment.Moment = moment()
): boolean => {
  const names = trainNames.filter((name): name is string => !!name);
  if (names.length === 0) {
    return false;
  }
  return names.every(name => isBusinessEkinetSupportedTrainName(name, at));
};
